module.exports = __webpack_public_path__ + "static/media/01.d95e3799.png";